<template>
  <div class="home">
  
    <Reproductor msg="Los consonantes" audio2="../mp3/PrimariaB/02PB.mp3" cover="../img/2.jpg" name="Primaria B - Lección #2"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
